import { css } from 'styled-jsx/css';

export default css`
  .pc-model-sales-highlights-container {
    display: none;
    width: 100%;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background: transparent;
  }
  .pc-model-sales-highlights-mobile-button {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 10px;
    cursor: pointer;
    height: 36px;
    background-color: #950810;
    border-top-left-radius: 20px;
    border-top-right-radius: 20px;
    box-shadow:
      0px -10px 20px rgba(0, 0, 0, 0.5),
      -10px 0px 20px rgba(0, 0, 0, 0.5),
      10px 0px 20px rgba(0, 0, 0, 0.5);
  }

  .pc-model-sales-highlights-mobile-button-text {
    display: flex;
    gap: 12px;
    font-family: 'Roboto-Medium';
    font-size: 12px;
  }
  .pc-model-sales-highlights-image {
    width: 90%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .pc-model-sales-highlights-list {
    width: 90%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: start;
    gap: 12px;
    padding: 21px 21px;
    background: #141414;
  }
  .pc-model-sales-highlights-item {
    width: 100%;
    display: flex;
    justify-content: start;
    align-items: center;
    gap: 16px;
  }
  .pc-model-sales-highlights-item > span {
    font-family: 'Roboto-Medium';
    font-size: 16px;
    font-weight: 500;
    color: #ffffff;
  }
  @media (max-width: 1024px) {
    .pc-model-sales-highlights-container {
      display: flex;
    }
  }
  @media (max-width: 430px) {
    .pc-model-sales-highlights-image {
      width: 100%;
    }
    .pc-model-sales-highlights-list {
      width: 100%;
    }
  }
`;
